import React from 'react';

import { Heading, Container, Row, Col, Text, className, ImageComponent } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';


export default function ProductsSection({
    title,
    titleTag,
    id,
    products,
    colorScheme
}) {
    colorScheme = colorScheme?.toLowerCase();
    const hasDetached = products.length % 2 ? true : false;
    const hasColorScheme = colorScheme !== 'none';

    return (
        <section aria-labelledby={id} className={`${sectionStyle['with-bg']} ${sectionStyle['with-bg--none']} ${colorStyle[`with-bg--${colorScheme}`]}`}>
            {hasColorScheme ? (
                <div
                    data-sal="fade"
                    data-sal-easing="ease-out-quart"
                    className={`${sectionStyle.bg} ${colorStyle.bg}`}
                />
            ) : null}
            <Container
                pt={{ xs: 10, lg: 20 }}
                pb={{ xs: 6, lg: 11 }}
            >
                <Row>
                    {title ? (
                        <Col>
                            <Heading
                                id={id}
                                className="h3 font-weight-bold mb-10"
                                tag={titleTag}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {title}
                            </Heading>
                        </Col>
                    ) : null}
                    {products.map((product, i) => {
                        let titleParts = [product.title];
                        const isDetached = hasDetached && !i;

                        if (product.store) {
                            titleParts.unshift(product.store.title);
                        }

                        return (
                            <Col
                                key={i}
                                col={{ lg: isDetached ? 12 : 6 }}
                                mb={{ xs: isDetached ? 10 : 9 }}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay={isDetached ? '' : `xs-none--lg-${(hasDetached ? ((i - 1) % 2) : (i % 2)) * 100}`}
                            >
                                <ImageComponent
                                    image={product[isDetached ? 'detachedImage' : 'defaultImage']}
                                    aspectRatio={isDetached ? 1.4375 : 1.782}
                                    className={`${style[`image${isDetached ? '--detached' : ''}`]} mb-3 d-lg-none`}
                                />
                                <ImageComponent
                                    image={product[isDetached ? 'detachedImage' : 'defaultImage']}
                                    aspectRatio={isDetached ? 2.63 : 2.117}
                                    className={`${style[`image${isDetached ? '--detached' : ''}`]} ${isDetached ? 'mb-5' : 'mb-3'} d-none d-lg-block`}
                                />
                                <div {...className('d-lg-flex justify-content-lg-between')}>
                                    <div {...className('pr-lg-3')}>
                                        <Text
                                            className={`h4 mb-1 ${colorStyle['color--primary']}`}
                                            tag="p"
                                        >{titleParts.join(' — ')}</Text>
                                        <Text
                                            className={`${isDetached ? 'h3' : 'h4'} mb-3 mb-lg-0`}
                                            tag="p"
                                        >{product.subtitle}</Text>
                                    </div>
                                    <div {...className('text-center')}>
                                        <ButtonComponent
                                            focusWhite={colorScheme == 'primary' ? true : false}
                                            blockMobile={true}
                                            button={{
                                                detached: true,
                                                externalLink: product.ctaUrl,
                                                label: product.ctaText,
                                                target: '_blank',
                                                extraAttributes: {
                                                    // title: product.linkTitle,
                                                    rel: 'noopener nofollow'
                                                },
                                            }}
                                        />
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </section>
    );
}